import { createQueue } from './lambdas/createQueue'

import type { TypedNode, ViewElement } from './models'
import type { MoveNodeItem } from './types'
import type { Callback } from '@rehaje/shared'

export const { add: addElementEffect, run: runElementEffect } =
  createQueue<ViewElement>()

export const { add: addNodeEffect, run: runNodeEffect } =
  createQueue<TypedNode>()

export const { add: addNodeEvaluate, run: runNodeEvaluate } =
  createQueue<Callback>()

export const { add: addNodeMove, run: runNodeMove } =
  createQueue<MoveNodeItem>()
